import {CSSObject, styled} from "@core-ui/react-stitch";
import {BackOrderMessageProps} from "../types";

export const BackOrderMessage = styled.span<BackOrderMessageProps>(
  ({hover, translateX, theme}) => {
    const hoverStyles: CSSObject = hover
      ? {
          height: "auto",
          width: "9.375rem",
          padding: "0.5rem",
          overflow: "visible",
        }
      : {};

    return {
      textAlign: "left",
      position: "absolute",
      top: 0,
      left: 0,
      height: 0,
      width: 0,
      overflow: "hidden",
      transform: `translate(
        ${translateX},
        calc(-100% - calc(0.75rem - ${translateX}))
      )`,
      fontSize: "0.75rem",
      color: theme.color.g1,
      zIndex: 10,
      textTransform: "none",
      backgroundColor: theme.color.wh,
      boxShadow: theme.utilities.dropShadow.boxShadow,
      borderRadius: "0.25rem",
      ...hoverStyles,
    };
  }
);
